/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

var _excluded = ["className", "children", "id"];
var GroupLabel = function GroupLabel(_ref) {
  var className = _ref.className,
    children = _ref.children,
    id = _ref.id,
    other = _objectWithoutProperties(_ref, _excluded);
  var classNames = classnames('cds--group-label', className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, react/jsx-props-no-spreading
    React.createElement("label", _extends({
      htmlFor: id,
      className: classNames
    }, other), children)
  );
};
GroupLabel.propTypes = {
  /**
   * Specify the content of the form label
   */
  children: PropTypes.node,
  /**
   * Provide a custom className to be applied to the containing <label> node
   */
  className: PropTypes.string,
  /**
   * Provide a unique id for the given <GroupLabel>
   */
  id: PropTypes.string
};
GroupLabel.defaultProps = {
  children: undefined,
  className: undefined,
  id: undefined
};
var GroupLabel$1 = GroupLabel;

export { GroupLabel$1 as default };
